import { ColDef } from "ag-grid-community";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { RowDef } from "../../components/ag-grid-extensions/models/RowDef";
import i18n from "../../services/localization-service/i18n";
import { IDateRange } from "../../common/models/IDateRange";
import { getTimeframeTimeDisplayText } from "../../common/utilities/TimeframeUtilities";
import { IAlarmInformation } from "../../services/admin-report-data-service/Models";

const projectRow = (
    entry: IAlarmInformation): RowDef => {

    let row: RowDef = {
    };

    row['deviceDisplayName'] = entry.deviceDisplayName;
    row['tagName'] = entry.tagName;
    row['setpointMessage'] = entry.setpointMessage;
    row['alarmTimestamp'] = entry.alarmTimestamp ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date(entry.alarmTimestamp)) : '';
    row['clearTimestamp'] = entry.clearTimestamp ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date(entry.clearTimestamp)) : '';
    row['clearMessage'] = entry.clearMessage;
    row['setpointName'] = entry.setpointName;
    row['recipients'] = entry.recipients;
    row['hoursInAlarm'] = entry.hoursInAlarm > 0 ? entry.hoursInAlarm.toString() : '';
    row['acknowledged'] = entry.acknowledged ? 'True' : 'False';
    row['acknowledgedBy'] = entry.acknowledgedBy;
    row['acknowledgedTimestamp'] = entry.acknowledgedTimestamp ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date(entry.acknowledgedTimestamp)) : '';
    row['alarmEndingReason'] = entry.alarmEndingReason;

    return row;
}

const AlarmNotificationAdminReportUtils = {

    createGridRows: function (entries: IAlarmInformation[] | undefined): RowDef[] {

        const rows: RowDef[] = entries?.sort((a, b) => (a.alarmTimestamp ? 
                                                        new Date(a.alarmTimestamp) : 
                                                        new Date()).getTime() - (b.alarmTimestamp ? 
                                                            new Date(b.alarmTimestamp) : 
                                                            new Date()).getTime()).map((o) => {

            return projectRow(o);

        }) ?? [];


        return rows;
    },
    createGridColumns: function (): ColDef[] {


        let cols: ColDef[] = [{
            headerName: i18n.t("alarmNotificationReports.device") as string,
            field: 'deviceDisplayName',
            sortable: true,
            pinned: 'left',
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.tag") as string,
            field: "tagName",
            sortable: true,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.setpointMessage") as string,
            field: "setpointMessage",
            sortable: true,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.alarmTimestamp") as string,
            field: "alarmTimestamp",
            sortable: true,
            //sort: "asc",
            type:"timestamp, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.cleartimestamp") as string,
            field: "clearTimestamp",
            sortable: true,
            type:"timestamp, multiline"
        }, {

            headerName: i18n.t("alarmNotificationReports.clearMessage") as string,
            field: "clearMessage",
            sortable: true,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.setpoint") as string,
            field: "setpointName",
            sortable: true,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.recipients") as string,
            field: "recipients",
            sortable: true,
            width: 300,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.hourscurrentlyinalarm") as string,
            field: "hoursInAlarm",
            sortable: true,
            type: "number"
        }, {
            headerName: i18n.t("alarmNotificationReports.acknowledged") as string,
            field: "acknowledged",
            sortable: true,
            type: "text"
        }, {
            headerName: i18n.t("alarmNotificationReports.acknowledgedBy") as string,
            field: "acknowledgedBy",
            sortable: true,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.acknowledgedTimestamp") as string,
            field: "acknowledgedTimestamp",
            sortable: true,
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("alarmNotificationReports.alarmEndingReason") as string,
            field: "alarmEndingReason",
            sortable: true,
            type: "text"
        }];

        return cols;
    },

    getGridNoDataMessage(tagName: string, dateRange?: IDateRange): string {

        let message = '';

        if (dateRange && dateRange.startDate && dateRange.endDate) {
            message = i18n.t("noData.noDataForObjectWithinDateRange", {
                startDate: dateRange.startDate.toLocaleString(),
                endDate: dateRange.endDate.toLocaleString(),
                objectName: tagName
            });

        } else {
            message = i18n.t("noData.noDataForObject", { objectName: tagName });
        }

        return message;
    },
    // async getData(groupID: number, filter: IAuditTrailFilter): Promise<IAuditTrail[]> {

    //     return AuditReportingDataService.getData(groupID,
    //         filter.startDate,
    //         filter.endDate,
    //         filter.searchText ? undefined : filter.action,
    //         filter.searchText ? undefined : filter.objectType,
    //         filter.searchText ? undefined : filter.userLogin,
    //         filter.searchText ? undefined : filter.objectName,
    //         filter.searchText ? undefined : filter.oldValue,
    //         filter.searchText ? undefined : filter.newValue,
    //         filter.searchText ? undefined : filter.additionalInfo,
    //         filter.searchText,
    //         filter.maxRows);
    // },
    // mapToAuditFilter(state: AuditReportingStateType): IAuditTrailFilter {

    //     const filter: IAuditTrailFilter = {
    //         startDate: state.durationOptions.duration.startDate,
    //         endDate: state.durationOptions.duration.endDate,
    //         action: state.auditAction,
    //         objectType: state.objectType,
    //         objectName: state.objectName,
    //         userLogin: state.userName,
    //         oldValue: state.oldValue,
    //         newValue: state.newValue,
    //         maxRows: state.maxRows,
    //         additionalInfo: state.additionalInfo,
    //         searchText: (state.searchText?.trim()?.length ?? 0) > 0 ? state.searchText?.trim() : undefined
    //     };

    //     return filter;
    // }
};

export default AlarmNotificationAdminReportUtils;
